export enum Arrow {
  left = 'left',
  right = 'right',
}

export enum TypeName {
  CUSTOM_TEACHING_ORDER = 'CustomTeachingOrder',
}

export type TeachingOrdersArr = Array<{ id: number; name: string; characters: any[] }>;

export type State = TeachingOrder & {
  activeTeachingOrderIndex: number;
  previousActiveIndex: number;
  serializedTeachingOrders?: any[];
  activeCharacters: any[];
  hasUnsavedChanges: boolean;
  activeTeachingOrder: any;
  isActiveTeachingOrderDisplayed: boolean;
  isSaving: boolean;
  resetSignal: number;
};

export type Action =
  | {
      type: 'SET_UNSAVED_CHANGES';
      payload: any;
    }
  | {
      type: 'SET_IS_SAVING';
      payload: { isSaving: boolean };
    }
  | {
      type: 'SET_TEACHING_ORDERS';
      payload: TeachingOrder;
    }
  | {
      type: 'SET_SELECTED_CHAR';
      payload: any;
    }
  | {
      type: 'UPDATE_ACTIVE_INDEX';
      payload: { activeTeachingOrderIndex: number; previousActiveIndex: number };
    }
  | {
      type: 'UPDATE_TEACHING_ORDER';
      payload: TeachingOrder;
    }
  | {
      type: 'BUMP_RESET_SIGNAL';
    };

export type TeachingOrder = {
  [teachingOrderId: number]: {
    __typename: string | null;
    id?: number | null;
    name: string | null;
    characters: any[];
    isInitialChange?: boolean;
    selectedChar?: string | null;
    arrow?: string | null;
  };
};

export type UseTeachingOrder = [
  State,
  {
    setTeachingOrder: (data: TeachingOrder) => void;
    setActiveTeachingOrderIndex: (activeTeachingOrderIndex: number) => void;
    confirmSettingTeachingOrder: (activeTeachingOrderIndex: number) => void;
    handleSetActiveTeachingOrder: (activeTeachingOrderIndex: number) => void;
    resetChanges: () => void;
    updateActiveTeachingOrder: (data: TeachingOrder) => void;
    handleCardChange: (characters: string[]) => void;
    handleArrowPress: (move: 'left' | 'right' | 'neither', idx: number, value) => void;
    setIsSaving: (isSaving: boolean) => void;
    handleSave: () => Promise<void>;
    handleSaveName: (newName: string) => void;
    handleExiting: () => void;
    requestForExitingEditMode: () => void;
  }
];
